exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media screen and (min-width: 1100px) {\n.card-header .btn-sm .plus[data-v-738c85ca] {\n    display: none;\n}\n}\n@media screen and (max-width: 1100px) {\n.card-header .btn-sm[data-v-738c85ca] {\n    line-height: 16px;\n}\n.card-header .btn-sm .button-text[data-v-738c85ca] {\n    display: none;\n}\n.card-header .btn-sm .plus[data-v-738c85ca] {\n    display: inline;\n}\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-738c85ca","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/t1/Admin/Organization.vue
// module id = 1853
// module chunks = 0